export var FlyoutSectionElementType;
(function (FlyoutSectionElementType) {
    FlyoutSectionElementType["offerGroupSection"] = "OfferGroupSection";
    FlyoutSectionElementType["linkSection"] = "LinkSection";
    FlyoutSectionElementType["teaserSection"] = "TeaserSection";
    FlyoutSectionElementType["providerSection"] = "ProviderSection";
    FlyoutSectionElementType["manufacturerSection"] = "ManufacturerSection";
})(FlyoutSectionElementType || (FlyoutSectionElementType = {}));
